/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Weight_EmptyInputs */

const en_us2_profile_weight_empty = /** @type {(inputs: Profile_Weight_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No weight logged yet.`)
};

const pt_br2_profile_weight_empty = /** @type {(inputs: Profile_Weight_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum peso registrado ainda.`)
};

const es_419_profile_weight_empty = /** @type {(inputs: Profile_Weight_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay peso registrado.`)
};

const pt_pt2_profile_weight_empty = /** @type {(inputs: Profile_Weight_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda nenhum peso registado.`)
};

const fr_fr2_profile_weight_empty = /** @type {(inputs: Profile_Weight_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun poids enregistré pour l'instant.`)
};

const de_de2_profile_weight_empty = /** @type {(inputs: Profile_Weight_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch kein Gewicht erfasst.`)
};

const it_it2_profile_weight_empty = /** @type {(inputs: Profile_Weight_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessun peso registrato.`)
};

/**
* | output |
* | --- |
* | "No weight logged yet." |
*
* @param {Profile_Weight_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_weight_empty = /** @type {((inputs?: Profile_Weight_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Weight_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_weight_empty(inputs)
	if (locale === "es-419") return es_419_profile_weight_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_weight_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_weight_empty(inputs)
	if (locale === "de-DE") return de_de2_profile_weight_empty(inputs)
	if (locale === "it-IT") return it_it2_profile_weight_empty(inputs)
	return en_us2_profile_weight_empty(inputs)
});
export { profile_weight_empty as "profile.weight_empty" }